(function () {
  'use strict';

  if (window.__pbBrazilGeoPopupInitialized) return;
  window.__pbBrazilGeoPopupInitialized = true;

  const CONFIG = {
    workerBaseUrl:
      'https://playbear-brazil-geo-router.rough-cell-5947.workers.dev',

    globalUrl:
      'https://playbearpx.com/?utm_source=playbear_brazil&utm_medium=owned&utm_campaign=pb_br_to_global_2026&utm_content=geo_popup',

    stayBrazilDays: 1
  };

  const KEYS = {
    visitorId: 'pb_br_geo_visitor_id',
    sessionId: 'pb_br_geo_session_id',
    stayBrazilUntil: 'pb_br_geo_stay_until',
    popupShown: 'pb_br_geo_popup_shown'
  };

  function makeId() {
    if (
      window.crypto &&
      typeof window.crypto.randomUUID === 'function'
    ) {
      return window.crypto.randomUUID();
    }

    return (
      Date.now().toString(36) +
      '-' +
      Math.random().toString(36).slice(2) +
      '-' +
      Math.random().toString(36).slice(2)
    );
  }

  function getVisitorId() {
    try {
      let id = localStorage.getItem(KEYS.visitorId);

      if (!id) {
        id = makeId();
        localStorage.setItem(KEYS.visitorId, id);
      }

      return id;
    } catch (e) {
      return makeId();
    }
  }

  function getSessionId() {
    try {
      let id = sessionStorage.getItem(KEYS.sessionId);

      if (!id) {
        id = makeId();
        sessionStorage.setItem(KEYS.sessionId, id);
      }

      return id;
    } catch (e) {
      return makeId();
    }
  }

  function hasChosenBrazilRecently() {
    try {
      const value =
        localStorage.getItem(KEYS.stayBrazilUntil);

      if (!value) return false;

      const until = Number(value);

      if (!Number.isFinite(until)) {
        localStorage.removeItem(KEYS.stayBrazilUntil);
        return false;
      }

      if (Date.now() >= until) {
        localStorage.removeItem(KEYS.stayBrazilUntil);
        return false;
      }

      return true;
    } catch (e) {
      return false;
    }
  }

  function rememberBrazilChoice() {
    try {
      const milliseconds =
        CONFIG.stayBrazilDays *
        24 *
        60 *
        60 *
        1000;

      localStorage.setItem(
        KEYS.stayBrazilUntil,
        String(Date.now() + milliseconds)
      );
    } catch (e) {
      // Ignore storage errors
    }
  }

  function popupAlreadyShownThisSession() {
    try {
      return (
        sessionStorage.getItem(KEYS.popupShown) === '1'
      );
    } catch (e) {
      return false;
    }
  }

  function markPopupShownThisSession() {
    try {
      sessionStorage.setItem(KEYS.popupShown, '1');
    } catch (e) {
      // Ignore storage errors
    }
  }

  function getPagePath() {
    return window.location.pathname.slice(0, 500);
  }

  async function trackEvent(eventType) {
    try {
      const response = await fetch(
        CONFIG.workerBaseUrl + '/event',
        {
          method: 'POST',
          mode: 'cors',
          cache: 'no-store',
          keepalive: true,
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            event_type: eventType,
            visitor_id: getVisitorId(),
            session_id: getSessionId(),
            page_path: getPagePath()
          })
        }
      );

      return response.ok;
    } catch (e) {
      return false;
    }
  }

  async function trackBeforeNavigation(eventType) {
    await Promise.race([
      trackEvent(eventType),
      new Promise(function (resolve) {
        setTimeout(resolve, 600);
      })
    ]);
  }

  function closePopup() {
    const popup =
      document.getElementById('pb-br-geo-popup');

    if (popup) {
      popup.classList.remove(
        'pb-br-geo-popup--visible'
      );

      window.setTimeout(function () {
        popup.hidden = true;
      }, 180);
    }

    document.documentElement.classList.remove(
      'pb-br-geo-popup-open'
    );
  }

  function showPopup(isTestMode) {
    const popup =
      document.getElementById('pb-br-geo-popup');

    if (!popup) return;

    /*
     * Test mode should not alter live
     * session state.
     */
    if (!isTestMode) {
      markPopupShownThisSession();
    }

    popup.hidden = false;

    window.requestAnimationFrame(function () {
      popup.classList.add(
        'pb-br-geo-popup--visible'
      );
    });

    document.documentElement.classList.add(
      'pb-br-geo-popup-open'
    );

    if (!isTestMode) {
      trackEvent('br_to_global_popup_shown');
    }
  }

  function bindPopupActions(isTestMode) {
    const globalButton =
      document.getElementById(
        'pb-br-geo-go-global'
      );

    const brazilButton =
      document.getElementById(
        'pb-br-geo-stay-brazil'
      );

    const closeButton =
      document.getElementById(
        'pb-br-geo-close'
      );

    if (globalButton) {
      globalButton.addEventListener(
        'click',
        async function () {
          globalButton.disabled = true;

          if (!isTestMode) {
            await trackBeforeNavigation(
              'br_to_global_redirect_click'
            );
          }

          window.location.assign(
            CONFIG.globalUrl
          );
        }
      );
    }

    function stayBrazil() {
      /*
       * Test mode must not create a
       * persistent 30-day preference.
       */
      if (!isTestMode) {
        rememberBrazilChoice();

        trackEvent(
          'br_to_global_stay_br'
        );
      }

      closePopup();
    }

    if (brazilButton) {
      brazilButton.addEventListener(
        'click',
        stayBrazil
      );
    }

    if (closeButton) {
      closeButton.addEventListener(
        'click',
        stayBrazil
      );
    }
  }

  async function init() {
    const params =
      new URLSearchParams(
        window.location.search
      );

    /*
     * Test mode:
     *
     * ?pb_geo_test=global
     *
     * Forces popup display.
     * Does not write D1 events.
     * Does not save 30-day choice.
     */
    const isTestMode =
      params.get('pb_geo_test') === 'global';

    bindPopupActions(isTestMode);

    if (isTestMode) {
      showPopup(true);
      return;
    }

    if (hasChosenBrazilRecently()) {
      return;
    }

    if (popupAlreadyShownThisSession()) {
      return;
    }

    try {
      const response = await fetch(
        CONFIG.workerBaseUrl + '/geo',
        {
          method: 'GET',
          mode: 'cors',
          cache: 'no-store'
        }
      );

      if (!response.ok) return;

      const data = await response.json();

      if (
        data &&
        data.ok === true &&
        data.should_recommend_global === true
      ) {
        showPopup(false);
      }
    } catch (e) {
      /*
       * Geo failure must never interfere
       * with normal Brazil-site browsing.
       */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      init,
      { once: true }
    );
  } else {
    init();
  }
})();